"use client";

import { cn } from "@/lib/utils";

import BetterPayAndCareerIcon from "@/components/icons/better-pay-and-career-icon";
import CaregiversIcon from "@/components/icons/caregivers-icon";
import ComfortableHeadsetIcon from "@/components/icons/comfortable-headset-icon";
import ComprehensiveAssistanceIcon from "@/components/icons/comprehensive-assistance-icon";
import ComprehensiveCareAndMonitoringIcon from "@/components/icons/comprehensive-care-and-monitoring-icon";
import ComprehensiveDailySupportIcon from "@/components/icons/comprehensive-daily-support-icon";
import ComprehensiveSupportIcon from "@/components/icons/comprehensive-support-icon";
import ContinuityOfCareIcon from "@/components/icons/continuity-of-care-icon";
import CostEffectiveSimplicityIcon from "@/components/icons/cost-effective-simplicity-icon";
import DevelopSpecializedSkillSetsIcon from "@/components/icons/develop-specialized-skill-sets-and-confidence-icon";
import DownloadIcon from "@/components/icons/download-icon";
import EffectiveSymptomControlIcon from "@/components/icons/effective-symptom-control-icon";
import EffortlessIntegrationIcon from "@/components/icons/effortless-integration-icon";
import EmotionalSupportIcon from "@/components/icons/emotional-support-icon";
import EmployeeModelIcon from "@/components/icons/employee-model-icon";
import EngagingLearningDesignIcon from "@/components/icons/engaging-learning-design-icon";
import EngagingLearningEnvironmentsIcon from "@/components/icons/engaging-learning-environments-icon";
import EnhancedDailyLivingIcon from "@/components/icons/enhanced-daily-living-icon";
import EnhancedDailyLivingSkillIcon from "@/components/icons/enhanced-daily-living-skill-icon";
import EnhancedQualityOfLifeIcon from "@/components/icons/enhanced-quality-of-life-icon";
import EnhancedRecoveryIcon from "@/components/icons/enhanced-recovery-icon";
import EnhancedSafetyIcon from "@/components/icons/enhanced-safety-icon";
import EnhancesRecoveryIcon from "@/components/icons/enhances-recovery-icon";
import ExceptionalCareIcon from "@/components/icons/exceptional-care-icon";
import FamilyCaregiversIcon from "@/components/icons/family-caregivers-icon";
import FlexibleLearningIcon from "@/components/icons/flexible-learning-icon";
import FlexibleStaffingIcon from "@/components/icons/flexible-staffing-icon";
import FocusOnPatientCareIcon from "@/components/icons/focus-on-patient-care-icon";
import GuaranteedExpertsIcon from "@/components/icons/guaranteed-experts-icon";
import HighQualityCareIcon from "@/components/icons/high-quality-care-icon";
import HolisticCoordinationIcon from "@/components/icons/holistic-coordination-icon";
import IconLightBulb from "@/components/icons/icon-light-bulb";
import ImmediateResponseIcon from "@/components/icons/immediate-response-icon";
import ImmersiveExperience360Icon from "@/components/icons/immersive-experience-360-icon";
import ImproveEmotionalWellBeingIcon from "@/components/icons/improve-emotional-well-being-icon";
import LessReadmissionRiskIcon from "@/components/icons/less-readmission-risk-icon";
import LiveWorkshopsIcon from "@/components/icons/live-workshops-icon";
import LiveagentBubbleIcon from "@/components/icons/liveagent-bubble-icon";
import LiveagentLogoIcon from "@/components/icons/liveagent-logo-icon";
import ManagingComplexRegimensIcon from "@/components/icons/managing-complex-regimens-icon";
import { Minus } from "@/components/icons/minus-icon";
import OpenCommunicationIcon from "@/components/icons/open-communication-icon";
import OperationalEfficiencyIcon from "@/components/icons/operational-efficiency-icon";
import PeaceOfMindIcon from "@/components/icons/peace-of-mind-icon";
import { Plus } from "@/components/icons/plus-icon";
import PreVettedTherapistsIcon from "@/components/icons/pre-vetted-therapists-icon";
import ProfessionallyDesignedScenariosIcon from "@/components/icons/professionally-designed-scenarios-icon";
import PromotingIndependenceIcon from "@/components/icons/promoting-independence-icon";
import QualityCertificationIcon from "@/components/icons/quality-certification-icon";
import ReassuresFamiliesIcon from "@/components/icons/reassures-families-icon";
import ReliableStaffingSolutionsIcon from "@/components/icons/reliable-staffing-solutions-icon";
import ResolutionIcon from "@/components/icons/resolution-icon";
import SaferHomeEnvironmentIcon from "@/components/icons/safer-home-environment-icon";
import SafetyAndComfortIcon from "@/components/icons/safety-and-comfort-icon";
import SeamlessTransitionHomeIcon from "@/components/icons/seamless-transition-home-icon";
import SimulatesRealClientInteractionIcon from "@/components/icons/simulates-real-client-interaction-icon";
import StaffCoordinator247Icon from "@/components/icons/staff-coordinator-24-7-icon";
import StrokePreventionIcon from "@/components/icons/stroke-prevention-icon";
import TailoredCarePlansIcon from "@/components/icons/tailored-care-plans-icon";
import WirelessPcVrTrainingIcon from "@/components/icons/wireless-pc-vr-training-icon";
import {
  ServicesForFamiliesIcon,
  StaffingIcon,
  ResourcesForFamilies,
  ResourcesForProfessionals,
  MapPin,
  Phone,
  Mail,
  Clock,
  CalendarIcon,
  FileIcon,
  ChatIcon,
} from "@/components/icons";

export const iconList = [
  // services icons
  "staffing-icon",
  "services-for-families-icon",
  "resources-for-families-icon",
  "resources-for-professionals-icon",

  // others
  "better-pay-and-career",
  "caregivers",
  "comfortable-headset",
  "comprehensive-assistance",
  "comprehensive-care-and-monitoring",
  "comprehensive-daily-support",
  "comprehensive-support",
  "continuity-of-care",
  "cost-effective-simplicity",
  "develop-specialized-skill-sets",
  "download",
  "effective-symptom-control",
  "effortless-integration",
  "emotional-support",
  "employee-model",
  "engaging-learning-design",
  "engaging-learning-environments",
  "enhanced-daily-living",
  "enhanced-daily-living-skill",
  "enhanced-quality-of-life",
  "enhanced-recovery",
  "enhanced-safety",
  "enhances-recovery",
  "exceptional-care",
  "family-caregivers",
  "flexible-learning",
  "flexible-staffing",
  "focus-on-patient-care",
  "guaranteed-experts",
  "high-quality-care",
  "holistic-coordination",
  "icon-light-bulb",
  "immediate-response",
  "immersive-experience-360",
  "improve-emotional-well-being",
  "less-readmission-risk",
  "live-workshops",
  "liveagent-bubble",
  "liveagent-logo",
  "managing-complex-regimens",
  "minus",
  "open-communication",
  "operational-efficiency",
  "peace-of-mind",
  "plus",
  "pre-vetted-therapists",
  "professionally-designed-scenarios",
  "promoting-independence",
  "quality-certification",
  "reassures-families",
  "reliable-staffing-solutions",
  "resolution",
  "safer-home-environment",
  "safety-and-comfort",
  "seamless-transition-home",
  "simulates-real-client-interaction",
  "staff-coordinator-24-7",
  "stroke-prevention",
  "tailored-care-plans",
  "wireless-pc-vr-training",
  "map-pin",
  "phone",
  "mail",
  "clock",
  "calendar",
  "file",
  "chat",
] as const;

export type IconName = (typeof iconList)[number];

interface GetIconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  className?: string;
  state?: string;
}

export function getIcon({ name, className, ...props }: GetIconProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const icons: Record<IconName, React.FC<any>> = {
    "staffing-icon": StaffingIcon,
    "services-for-families-icon": ServicesForFamiliesIcon,
    "resources-for-families-icon": ResourcesForFamilies,
    "resources-for-professionals-icon": ResourcesForProfessionals,
    "better-pay-and-career": BetterPayAndCareerIcon,
    caregivers: CaregiversIcon,
    "comfortable-headset": ComfortableHeadsetIcon,
    "comprehensive-assistance": ComprehensiveAssistanceIcon,
    "comprehensive-care-and-monitoring": ComprehensiveCareAndMonitoringIcon,
    "comprehensive-daily-support": ComprehensiveDailySupportIcon,
    "comprehensive-support": ComprehensiveSupportIcon,
    "enhanced-safety": EnhancedSafetyIcon,
    "enhances-recovery": EnhancesRecoveryIcon,
    "exceptional-care": ExceptionalCareIcon,
    "family-caregivers": FamilyCaregiversIcon,
    "flexible-learning": FlexibleLearningIcon,
    "flexible-staffing": FlexibleStaffingIcon,
    "focus-on-patient-care": FocusOnPatientCareIcon,
    "guaranteed-experts": GuaranteedExpertsIcon,
    "high-quality-care": HighQualityCareIcon,
    "holistic-coordination": HolisticCoordinationIcon,
    "immediate-response": ImmediateResponseIcon,
    "immersive-experience-360": ImmersiveExperience360Icon,
    "improve-emotional-well-being": ImproveEmotionalWellBeingIcon,
    "less-readmission-risk": LessReadmissionRiskIcon,
    "live-workshops": LiveWorkshopsIcon,
    "liveagent-bubble": LiveagentBubbleIcon,
    "liveagent-logo": LiveagentLogoIcon,
    "managing-complex-regimens": ManagingComplexRegimensIcon,
    "open-communication": OpenCommunicationIcon,
    "operational-efficiency": OperationalEfficiencyIcon,
    "peace-of-mind": PeaceOfMindIcon,
    "pre-vetted-therapists": PreVettedTherapistsIcon,
    "professionally-designed-scenarios": ProfessionallyDesignedScenariosIcon,
    "promoting-independence": PromotingIndependenceIcon,
    "quality-certification": QualityCertificationIcon,
    "reassures-families": ReassuresFamiliesIcon,
    "reliable-staffing-solutions": ReliableStaffingSolutionsIcon,
    resolution: ResolutionIcon,
    "safer-home-environment": SaferHomeEnvironmentIcon,
    "safety-and-comfort": SafetyAndComfortIcon,
    "seamless-transition-home": SeamlessTransitionHomeIcon,
    "simulates-real-client-interaction": SimulatesRealClientInteractionIcon,
    "staff-coordinator-24-7": StaffCoordinator247Icon,
    "stroke-prevention": StrokePreventionIcon,
    "tailored-care-plans": TailoredCarePlansIcon,
    "wireless-pc-vr-training": WirelessPcVrTrainingIcon,
    "continuity-of-care": ContinuityOfCareIcon,
    "cost-effective-simplicity": CostEffectiveSimplicityIcon,
    "develop-specialized-skill-sets": DevelopSpecializedSkillSetsIcon,
    download: DownloadIcon,
    "effective-symptom-control": EffectiveSymptomControlIcon,
    "effortless-integration": EffortlessIntegrationIcon,
    "emotional-support": EmotionalSupportIcon,
    "employee-model": EmployeeModelIcon,
    "engaging-learning-design": EngagingLearningDesignIcon,
    "engaging-learning-environments": EngagingLearningEnvironmentsIcon,
    "enhanced-daily-living": EnhancedDailyLivingIcon,
    "enhanced-daily-living-skill": EnhancedDailyLivingSkillIcon,
    "enhanced-quality-of-life": EnhancedQualityOfLifeIcon,
    "enhanced-recovery": EnhancedRecoveryIcon,
    "icon-light-bulb": IconLightBulb,
    minus: Minus,
    plus: Plus,
    "map-pin": MapPin,
    phone: Phone,
    mail: Mail,
    clock: Clock,
    calendar: CalendarIcon,
    file: FileIcon,
    chat: ChatIcon,
  };

  const Icon = icons[name];

  if (!Icon) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <Icon
      className={cn(className)}
      {...props}
    />
  );
}
